module.exports = __webpack_public_path__ + "static/media/explore_04.3d70b384.jpg";